// extracted by mini-css-extract-plugin
export default {"entryRow":"notification-inbox-entry_entryRow__beS-t"};